import { Component } from 'preact';
import { connect } from 'unistore/preact';
import { getKey } from '../../../../common/src/utils/common';
import { clientMessage, equalsIgnoreCase } from '../../utils/common';
import Notification from '../notification';
import CONSTANT from '../../utils/constants';
import { ELEMENT_PAYMODE } from '../../../../common/src/constant';
import SwitchUser from '../switchUser';

class ElementsHeader extends Component {
  constructor(props) {
    super(props);
    this.label = getKey(
      clientMessage(CONSTANT.HEADER.toLowerCase(), this.props.cache),
      'label',
      {}
    );
  }

  render({
    showOtpSent,
    notificationMsg,
    loginInfo,
    sessionExpired = false,
    cache,
    checkoutElementPayMode
  }) {
    const paymentOption = cache.getData('paymentOptions');
    const userDetails = getKey(paymentOption, 'userDetails');
    const isPayWithPaytmElementPayMode = equalsIgnoreCase(
      checkoutElementPayMode,
      ELEMENT_PAYMODE.PAY_WITH_PAYTM
    );
    return (
      <div>
        {showOtpSent && (
          <p className={`ptm-top-msg ptm-green-bh ptm-pos-a`}>{this.label.otpSend}</p>
        )}
        {notificationMsg && (
          <div className={`ptm-notify-wrap ptm-top-msg ptm-pos-a`}>
            <Notification />
          </div>
        )}
        {isPayWithPaytmElementPayMode && getKey(loginInfo, 'userLoggedIn') && !sessionExpired && (
          <div className={`ptm-switch-userwrap`}>
            <SwitchUser {...{ userDetails }} />
          </div>
        )}
      </div>
    );
  }
}

export default connect(
  'showOtpSent, notificationMsg, cache, loginInfo, sessionExpired, checkoutElementPayMode'
)(ElementsHeader);



// WEBPACK FOOTER //
// ./components/elements-header/index.js